// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavBar-module--nav--1LfY9","wrapper":"NavBar-module--wrapper--29PGy","logo":"NavBar-module--logo--3GsGv","controls":"NavBar-module--controls--6UtDX"};